import * as React from 'react';
import {Button, ButtonToolbar, Modal} from 'reactstrap';
import {change, Field, InjectedFormProps, reduxForm, reset} from 'redux-form';
import renderSelectField from '../../../../theme/components/form/Select';
import validate from './validate';
import {mirana} from '@wize/mirana-proto/mirana-proto';

interface VisicoolerNuevoModalProps {
    toggle: any;
    isOpen: boolean;
    cliente?: mirana.IUIVisicooler;
    modelos?: mirana.IVisicoolerModelo[];
}

interface VisicoolerNuevoModalState {
    cuota?: number;
}

class VisicoolerNuevoModal extends React.PureComponent<InjectedFormProps & ReduxProps & VisicoolerNuevoModalProps, VisicoolerNuevoModalState> {

    constructor(props) {
        super(props);
        this.state = {};
    }

    private handleReset = () => {
        this.props.dispatch(reset('visicooler_nuevo_form'));
        this.setState({cuota: undefined});
        this.props.toggle();
    };

    private get modelosList() {
        const options = [] as any;
        this.setState({cuota: undefined});
        if (this.props.modelos) {
            this.props.modelos.forEach((modelo) => {
                options.push({value: modelo.modeloId, label: modelo.descripcion});
            });
        }
        return options;
    }

    private handleModeloChange = (obj) => {
        if (this.props.modelos) {
            const modelo = this.props.modelos.find((modelo) => {
                return modelo.modeloId === obj.value;
            });
            this.setState({cuota: modelo ? modelo.cuota : null});
        }
    };

    public componentWillReceiveProps(props) {
        this.props.dispatch(change('visicooler_nuevo_form', 'clienteId', props.cliente ? props.cliente.clienteId : ''));
        this.props.dispatch(change('visicooler_nuevo_form', 'fuerzaVentaId', props.cliente ? props.cliente.fuerzaVentaId : ''));
    }

    public render() {
        const {handleSubmit, isOpen, toggle, cliente} = this.props;
        return (
            <Modal isOpen={isOpen} toggle={toggle}
                   className={`modal-dialog--primary`}>
                <div className='modal__header'>
                    <span className='lnr lnr-cross modal__close-btn' onClick={toggle}/>
                    <h4 className='bold-text  modal__title'>Asignar visicooler</h4>
                </div>
                <div className='modal__body modelo-modal'>
                    <h5>Código: {cliente ? cliente.clienteId : null}</h5>
                    <h5 style={{marginBottom: '12px'}}>Razón Social: {cliente ? cliente.clienteRazonSocial : null}</h5>
                    <span className='separator'/>
                    <form className='material-form' onSubmit={handleSubmit}>
                        <div className='form__form-group'>
                            <label className='form__form-group-label'>Modelos </label>
                            <div className='form__form-group-field'>
                                <Field
                                    name='modelo'
                                    component={renderSelectField}
                                    placeholder='Seleccione'
                                    options={this.modelosList}
                                    onChange={this.handleModeloChange}
                                />
                            </div>
                        </div>
                        <h5 style={{marginTop: '12px'}}>{this.state.cuota ? 'Cuota: S/' + this.state.cuota : null}</h5>
                        <ButtonToolbar className='modal__footer'>
                            <Button onClick={this.handleReset}>Cancelar</Button>{' '}
                            <Button type='submit' color='primary'>Aceptar</Button>
                        </ButtonToolbar>
                    </form>
                </div>
            </Modal>)
    }
}

export default reduxForm({
    form: 'visicooler_nuevo_form', // a unique identifier for this form
    destroyOnUnmount: true,
    validate,
})(VisicoolerNuevoModal);


// WEBPACK FOOTER //
// ./src/components/pages/visicooler/nuevo/visicooler-nuevo-modal.tsx